import Vue from 'vue';
import Vuex from 'vuex';
import { database as db } from 'firebase/app';
import 'firebase/database';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: null,
    state: null,
    type: null,
    packageName: null,
    price: {
      package: 0,
      state: 0,
    },
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setPrice(state, { statePrice, packagePrice }) {
      state.price.package = packagePrice;
      state.price.state = statePrice;
    },
    firebase(state, { field, value }) {
      state[field] = value;
    },
  },
  actions: {
    async setToken({ state, commit }) {
      if (!state.token) {
        const { key } = await db()
          .ref('info')
          .push();
        commit('setToken', key);
      }
      const ref = db().ref(`info/${state.token}`);
      // eslint-disable-next-line
      for (const field of ['type', 'state', 'packageName']) {
        ref.child(field).on('value', snapshot => {
          commit('firebase', { field, value: snapshot.val() });
        });
      }
    },
    choose({ state }, payload) {
      return db()
        .ref(`info/${state.token}/`)
        .update(payload);
    },
    async recalculatePrice({ state, commit }) {
      const statePrice = (await db()
        .ref(`prices/${state.state}/${state.type}`)
        .once('value')).val();
      const packagePrice = (await db()
        .ref(`prices/${state.packageName}`)
        .once('value')).val();
      commit('setPrice', { statePrice, packagePrice });
    },
  },
  strict: process.env.NODE_ENV !== 'production',
});

export default store;
